var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.344,
    height: 88.664,
    viewBox: "0 0 97.344 88.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20091",
    "data-name": "Group 20091",
    transform: "translate(2.132 2.077)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44477",
    "data-name": "Path 44477",
    d: "M34.263,62.776c-1.271-12.706-2.752-25.453-8.495-37.028-1.441-2.905-5.7-10.639-10.042-7.521-3.932,2.828-1.758,9.766-.27,13.282C20.248,42.831,28.447,51.994,34.263,62.776Z",
    transform: "translate(58.949 -17.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44478",
    "data-name": "Path 44478",
    d: "M106.713,72.744c-12.758-6.812-24.184-18.55-36.035-26.988-9.664-6.88-23.809-14.7-35.96-15.589-11.712-.854-15.782,10.264-7,17.866,11.486,9.948,30.125,10.4,44.4,13.193C83.39,63.432,96.179,68.484,106.713,72.744Z",
    transform: "translate(-22.984 -17.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44479",
    "data-name": "Path 44479",
    d: "M77.322,89.848c-13.182-1.937-27.695-6.8-40.667-2.466-3.5,1.169-12.343,6.35-9.024,11.332,3.24,4.863,9.215,3.66,13.957,2.471,8.624-2.163,16.743-5.773,25.195-8.484C70.237,91.593,73.921,91.135,77.322,89.848Z",
    transform: "translate(2.492 -17.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.ecee641e67ac907ce16b2dc880b19d39.svg";
export { ForwardRef as ReactComponent };